import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSpinnerOverlayComponent} from '../components/mat-spinner-overlay/mat-spinner-overlay.component';
import {TranslateModule} from "@ngx-translate/core";


@NgModule({
  declarations: [
    MatSpinnerOverlayComponent,
  ],
    imports: [
        CommonModule,
        MatProgressSpinnerModule,
        TranslateModule,
    ],
  exports: [
    MatSpinnerOverlayComponent,
  ],
})
export class MatSpinnerOverlayModule {
}
